import { getApiClient } from '@treneo/infrastructure/api';

import { OrganizationsApi } from './organizations.api';

export * from './organizations.api';
export * from './organizations-endpoints.constants';
export * from './organizations-http-methods.constants';

export const organizationsApi = new OrganizationsApi(getApiClient());
